var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileBannerBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 70,
    viewBox: "0 0 396 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_10570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 70,
    rx: 12,
    fill: "#F3F6FB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_f_4003_10570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.762 -84.7737C274.785 -65.1866 265.838 -27.8486 276.411 -0.916336C286.782 25.8119 316.672 42.1345 339.65 67.6386C362.83 92.9386 379.097 127.216 403.904 135.785C428.712 144.355 462.059 127.012 483.613 101.712C505.167 76.412 514.927 42.9507 515.944 8.46916C516.757 -25.8083 508.827 -61.1059 487.273 -80.489C465.719 -100.076 430.542 -103.749 394.347 -104.769C358.153 -105.789 320.942 -104.157 297.762 -84.7737Z",
    fill: "#4862EE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter1_f_4003_10570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.303253 24.4877C-11.562 34.644 -16.1821 54.0044 -10.722 67.9693C-5.36688 81.8284 10.0685 90.292 21.9338 103.516C33.9041 116.635 42.3043 134.408 55.1146 138.852C67.9249 143.295 85.1453 134.303 96.2755 121.184C107.406 108.065 112.446 90.7152 112.971 72.8359C113.391 55.0624 109.296 36.7599 98.1656 26.7094C87.0353 16.5531 68.8699 14.6488 50.1794 14.1198C31.489 13.5909 12.2735 14.4372 0.303253 24.4877Z",
    fill: "#FC7750"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    filter: "url(#filter2_f_4003_10570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.742 283.136C188.516 253.961 174.658 218.154 150.652 202.003C126.929 185.904 93.0587 189.461 59.6585 181.534C26.2069 173.891 -6.65822 154.932 -31.94 161.979C-57.2218 169.026 -74.8044 202.248 -78.1608 235.315C-81.5172 268.381 -70.5315 301.46 -51.7718 330.41C-32.9607 359.076 -6.37552 383.613 22.3749 387.312C51.2413 391.179 82.273 374.209 112.634 354.479C142.995 334.748 172.685 312.258 180.742 283.136Z",
    fill: "#4862EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4003_10570",
    x: 152,
    y: -225,
    width: 484,
    height: 483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_4003_10570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4003_10570",
    x: -133,
    y: -106,
    width: 366,
    height: 366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_4003_10570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4003_10570",
    x: -198.761,
    y: 40.437,
    width: 501.67,
    height: 467.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_4003_10570"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_10570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 70,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBannerBg);
export default __webpack_public_path__ + "static/media/mobile-banner-bg.1531a2a0bbc705faa4053fa4863495c1.svg";
export { ForwardRef as ReactComponent };